import React from "react";
import DirectEquityFilter from "../../components/DirectEquityFilter/DirectEquityFilter";
import {
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getPrintDate,
  //printDocument,
} from "../../utils/functions";
import UserStore from "../../store/UserStore";

const SubAssetFilter = ({
  reportName,
  printId,
  exportDetails,
  selectedInstrument,
  search,
  setSearch,
  sheetName,
  restrictHover,
  getFirstTimePdfTableData,
  columns,
}) => {
  return (
    <>
      <DirectEquityFilter
        exportExcel={() => {
          exportExcel({
            isInstrumentSummary: true,
            sheetname: sheetName,
            columns: columns,
            data: getFirstTimePdfTableData(),
            reportDetails: {
              relatioshipManager: exportDetails?.find(
                (item) => item.role === "RM",
              )?.name,
              serviceManager: exportDetails?.find((item) => item.role === "CXO")
                ?.name,
              date: getPrintDate(getAsOfDate(UserStore.asOfDate)),

              clientName:
                UserStore.getData === "fam"
                  ? UserStore.userData?.family_name
                  : UserStore.userData?.full_name,
            },
            excelName: `${reportName} - ${getCurrentDate()}`,
          });
        }}
        exportPdf={() => {
          // printDocument(printId, {
          //   width: 950,
          //   height: 800,
          //   name: reportName,
          // });

          return downloadPDFFile({
            headerName: sheetName,
            fileId: printId,
            name: reportName,
            columns: columns,
            data: getFirstTimePdfTableData(),
          });
        }}
        title2={selectedInstrument?.vehicleData?.assetClass?.name}
        search={search}
        setSearch={(data, isClosed) => {
          setSearch(data, isClosed);
        }}
        restrictHover={restrictHover}
      />
    </>
  );
};

export default SubAssetFilter;
